<div class="my-0">
	<div class="w-full px-2">
		<div class="slider_cont flex justify-between items-center">
			<div class="min_max_count">
				<div class="">
					<input type="number" name="min"
						   [(ngModel)]="control.value1" #min
						   (change)="triggerInput(+min.value, control.value2)"/>
				</div>
				<div class="">
					<input type="number" name="max"
						   [ngModel]="control.value2" #max
						   (change)="triggerInput(control.value1, +max.value)"/>
				</div>
				<div class="reset_button_cont">
					<button (click)="reset()">
						<span class="material-symbols-outlined">
							restart_alt
						</span>
					</button>
				</div>
			</div>
			<div class="slider_cont_inner">
				<mat-slider
					[max]="control.max"
					[min]="control.min"
					color="primary"
					class=""
					style="width: 90%">
					<input #minThumb
						   (input)="triggerSlider(+minThumb.value, +maxThumb.value)"
						   [value]="control.value1"
						   matSliderStartThumb>
					<input #maxThumb
						   (input)="triggerSlider(+minThumb.value, +maxThumb.value)"
						   [value]="control.value2"
						   matSliderEndThumb>
				</mat-slider>

			</div>
		</div>
	</div>
</div>
